import Dialog from '@/components/Dialog';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ContentSection = styled(Box)(() => ({
  overflowY: 'auto',
  position: 'relative',
  paddingLeft: '432px',
  paddingRight: '32px',
  height: '416px',
  boxSizing: 'content-box',
}));

export const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    maxWidth: '864px',
    width: '864px',
    height: '464px',
    maxHeight: '464px',
    borderRadius: '12px',
    position: 'relative',
    overflow: 'visible',
  },
  '& .MuiDialogContent-root': {
    paddingBottom: '16px',
    paddingRight: 0,
    paddingLeft: '32px',
    overflowY: 'hidden',
    overflowX: 'hidden',
  },
  '& .MuiDialogTitle-root': {
    paddingTop: '16px',
    paddingBottom: '16px',
  },
  '& .MuiIconButton-root[aria-label="close"]': {
    position: 'absolute !important',
    right: '-40px !important',
    top: '-8px !important',
    color: '#ffffff !important',
    padding: '8px',
  },
  '& .MuiIconButton-root[aria-label="close"] svg': {
    color: '#ffffff !important',
    fill: '#ffffff !important',
  },
}));
